import { Clock, Stethoscope, Wallet } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { FinancePanel } from "@/components/financeiro/finance-panel";
import { Timeline } from "@/components/timeline/timeline";
import type { PersonDetail } from "@/api/db/people";
import { PessoaLabels } from "@/lib/labels";

import { FichaAgenda } from "./ficha-agenda";
import { FichaClinico } from "./ficha-clinico";
import { FocusTarget } from "./ficha-focus";
import { FichaProvenance } from "./ficha-provenance";
import { FichaRegistro } from "./ficha-registro";
import { SideBlock, SubHeader } from "./ficha-sections";
import { FichaSharedPhone } from "./ficha-shared-phone";
import { FichaSubmissions } from "./ficha-submissions";

const REG = PessoaLabels.registry;

function Clinico({ person, isDoctor }: { person: PersonDetail; isDoctor: boolean }) {
	return (
		<FocusTarget id="clinico" className="flex flex-col gap-3">
			<SubHeader icon={<Stethoscope className="size-4" />} title={REG.clinico} />

			<Card>
				<CardContent>
					<FichaClinico person={person} isDoctor={isDoctor} />
				</CardContent>
			</Card>
		</FocusTarget>
	);
}

function TimelineSection({ personId }: { personId: number }) {
	return (
		<section className="flex min-w-0 flex-col gap-3 xl:absolute xl:inset-0">
			<SubHeader icon={<Clock className="size-4" />} title={PessoaLabels.side.timeline} />

			<Card className="flex min-h-0 flex-1 overflow-hidden">
				<CardContent className="flex min-h-0 flex-1 flex-col">
					<Timeline personId={personId} />
				</CardContent>
			</Card>
		</section>
	);
}

export function FichaCadastro({ person, isDoctor }: { person: PersonDetail; isDoctor: boolean }) {
	return (
		<div className="flex flex-col gap-5">
			<FichaSharedPhone person={person} />

			<FocusTarget id="cadastro">
				<FichaRegistro person={person} />
			</FocusTarget>

			<div className="grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1.1fr)_minmax(26rem,0.9fr)]">
				<div className="flex min-w-0 flex-col gap-5">
					<Clinico person={person} isDoctor={isDoctor} />

					<FocusTarget id="financeiro">
						<SideBlock icon={<Wallet className="size-4" />} title={PessoaLabels.side.financeiro}>
							<FinancePanel identity={{ personId: person.id }} />
						</SideBlock>
					</FocusTarget>

					<FichaProvenance person={person} />

					<FichaAgenda personId={person.id} />
				</div>

				<div className="min-w-0 xl:relative">
					<TimelineSection personId={person.id} />
				</div>
			</div>

			<FichaSubmissions personId={person.id} />
		</div>
	);
}
